import { initReactI18next } from 'react-i18next';
import { enUs } from '@components/organisms/language-selector/mui/en-us';
import { LangEnum } from '@models/enums';
import { arSA, deDE, esES, frFR, ptPT, ruRU, zhCN, zhTW } from '@mui/material/locale';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

export const MUI_LOCALES = {
    en: enUs,
    es: esES,
    pt: ptPT,
    ru: ruRU,
    de: deDE,
    fr: frFR,
    ar: arSA,
    [LangEnum.ZH_CN]: zhCN,
    [LangEnum.ZH_HANT]: zhTW,
};

export const AVAILABLE_LANGUAGES = [
    LangEnum.EN,
    LangEnum.RU,
    LangEnum.ES,
    LangEnum.PT,
    LangEnum.DE,
    LangEnum.FR,
    LangEnum.AR,
    LangEnum.ZH_CN,
    LangEnum.ZH_HANT,
];

let i18nInstance: ReturnType<typeof i18n.createInstance> | null = null;

export const createLocalization = () => {
    if (i18nInstance) {
        return i18nInstance;
    }

    i18nInstance = i18n.createInstance();

    i18nInstance
        .use(initReactI18next)
        .use(Backend)
        .use(LanguageDetector)
        .init({
            backend: {
                loadPath:
                    'https://cdn.n37z.com/i18n/translations/web-sdk/docs-verification-widget/{{lng}}.json',
            },
            fallbackLng: LangEnum.EN,
            interpolation: {
                escapeValue: false,
            },
        });

    return i18nInstance;
};
